export default __webpack_public_path__ + "static/media/AAE-Fire-Fx-00.27ef1f17.jpg";